import { useEffect } from "react";
import { api } from "../lib/api";
import { useLang } from "../context/LangContext";

function setMeta(attr, name, content) {
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content || "");
}

export function Seo({ page, robotsOverride }) {
  const { lang } = useLang();
  useEffect(() => {
    let active = true;
    api.get(`/public/seo/${page}`).then((r) => {
      if (!active) return;
      const s = r.data;
      const title = s.title?.[lang] || s.title?.es || "Natur Commodities";
      const desc = s.description?.[lang] || s.description?.es || "";
      document.title = title;
      setMeta("name", "description", desc);
      setMeta("name", "robots", robotsOverride || s.robots || "index,follow");
      setMeta("property", "og:title", title);
      setMeta("property", "og:description", desc);
      setMeta("property", "og:type", "website");
      setMeta("property", "og:url", window.location.href);
      if (s.og_image) setMeta("property", "og:image", s.og_image);
      let canonical = document.head.querySelector('link[rel="canonical"]');
      if (!canonical) {
        canonical = document.createElement("link");
        canonical.setAttribute("rel", "canonical");
        document.head.appendChild(canonical);
      }
      canonical.setAttribute("href", window.location.origin + window.location.pathname);
    }).catch(() => {});
    return () => { active = false; };
  }, [page, lang, robotsOverride]);
  return null;
}
